"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorAbilityState = void 0;
class ActorAbilityState {
    constructor(abilityType, targetType, coolDownTurns, maxUses = -1) {
        this.abilityType = abilityType;
        this.targetType = targetType;
        this.coolDownTurns = coolDownTurns;
        this.maxUses = maxUses;
        this.disabled = false;
        this.invokeCounter = 0;
        this.cooldownEventHandlerId = 0;
    }
}
exports.ActorAbilityState = ActorAbilityState;
